export const KeywordSearchRepository = Symbol.for('KeywordSearchRepository');
